<template>
  <div class="navbar-right-menus">
    <el-select
      v-if="organizations.length > 1"
      trigger="click"
      size="medium"
      :value="currentOrg.id"
      class="mr-m"
      @change="changeOrg"
    >
      <el-option
        v-for="org in organizations"
        :key="org.id"
        :value="org.id"
        :label="org.id"
      >
        {{ org.id }}
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import authServices from "@/services/auth";
import profileServices from "@/services/profile";
import organizationServices from "@/services/organization";

export default {
  name: 'RightMenus',
  data() {
    return {
      organizations: profileServices.getProfiles()?.organizations || [],
      currentOrg: organizationServices.getCurrentOrg(),
    }
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
  },
  methods: {
    logout() {
      authServices.logout();
    },
    changeOrg(orgId) {
      organizationServices.setCurrentOrg(this.organizations.find((org) => org.id === orgId));
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-right-menus {
  float: right;
  height: 100%;
  line-height: 50px;
  display: flex;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: white;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      margin-top: 5px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>
